import { useState } from "react";
import * as s from "styles/ModalCommonStyled";
import StepperComponent, { StepType } from "components/blocks/stepper/Stepper";
import ModalSubMenu from "components/blocks/modal/menu/ModalSubMenu";
import BigButton from "components/atoms/buttons/BigButton";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";

import TextArea from "components/atoms/input/TextArea";
import { intervalOptions } from "utils/options";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";

import TimeSelect from "components/atoms/select/date/TimeSelect";
import DefaultThumbnail from "components/atoms/image/DefaultThumbnail";
import SelectComponent from "components/atoms/select/SelectComponent";
import { Option } from "utils/options";

type Props = {
  steps: Array<StepType>;
  page: number;
  onChangePage: (name: string, index?: number) => void;
};
const addCvvListData = () => {
  let temp = [];

  for (let i = 0; i < 9; i++) {
    temp.push({
      cameraName: `Camera Channel Name ${i + 1}`,
      url: "staging/{ae310607-6bd9-931e-ba28-689bd8da3048}/{8236e03f-2449-486c-8e3d-9b3a64eb8251}/0/{01660dea-2363-be2b-69c2-985643494729}/80x85za7zocz3ylqulek495e7ekwhq.jpg",
    });
  }
  return temp;
};

export const enum RECORDER_MENU {
  ADD_RECORDER = "addRecorders",
  ADD_RECORDER_GROUP = "addRecorderGroups",
}

const recorderMenus = [
  {
    label: "Add Recorders",
    value: RECORDER_MENU.ADD_RECORDER,
    placeholder: "Search Individual Recorders",
  },
  {
    label: "Add Recorder Groups",
    value: RECORDER_MENU.ADD_RECORDER_GROUP,
    placeholder: "Search Recorder Groups",
  },
];

export default function AddTimlapsePresenter(props: Props): JSX.Element {
  const [currentMenu, setCurrentMenu] = useState<RECORDER_MENU>(
    RECORDER_MENU.ADD_RECORDER
  );
  const onChangeMenu = (value: string) => {
    setCurrentMenu(value as RECORDER_MENU);
  };
  // const addUserColumns: TableColumn<DATA.AddUserData>[] = [
  //   {
  //     name: "Name",
  //     selector: (row) => row.name,
  //   },
  //   {
  //     name: "Email",
  //     selector: (row) => row.email,
  //   },
  // ];
  // const addUserGroupColumns: TableColumn<DATA.AddUserGroupData>[] = [
  //   {
  //     name: "Name",
  //     selector: (row) => row.name,
  //   },
  //   {
  //     name: "Users",
  //     selector: (row) => row.users,
  //     center: true,
  //   },
  //   {
  //     name: "Email",
  //     cell: (row) => <input type="checkbox" checked={row.emailCheck} />,
  //   },
  //   {
  //     name: "Push",
  //     cell: (row) => <input type="checkbox" checked={row.pushCheck} />,
  //   },
  // ];
  // step 0 - recorders sub menu

  // step 1 - recipients sub menu
  // const recipientsMenus = [
  //   {
  //     label: "Add Users",
  //     value: true,
  //     placeholder: "Search users or add new ones via email.",
  //     columns: addUserColumns,
  //     data: DATA.addUserData,
  //   },
  //   {
  //     label: "Add User Groups",
  //     value: false,
  //     placeholder: "Search Groups",
  //     columns: addUserGroupColumns,
  //     data: DATA.addUserGroupsData,
  //   },
  // ];

  const pages = [
    // recorders
    <s.ModalInnerHalf>
      <s.CheckInput>
        <input
          type="checkbox"
          data-testid="reports-add-timelapse-input-auto-apply-recorder"
        />{" "}
        Apply to all current and future recorders.
      </s.CheckInput>
      <ModalSubMenu
        menus={recorderMenus}
        currentMenu={recorderMenus.findIndex(
          (menu) => menu.value === currentMenu
        )}
        onChange={onChangeMenu}
      />

      {/* <SearchInput placeholder={recorderMenus[currentMenu].placeholder} /> */}
      {/* <s.ModalTableContainer>
       <ModalTable
         columns={recorderMenus[currentMenu].columns}
         data={recorderMenus[currentMenu].data}
       />
      </s.ModalTableContainer> */}
    </s.ModalInnerHalf>,
    // Camera
    <s.ModalInnerHalf>
      <s.CvvReportStatus>
        <span>
          <Text bold color={COLORS.BUTTONS1}>
            Recorders:
          </Text>
          <Text>7/10</Text>
        </span>
        <span>
          <Text bold color={COLORS.BUTTONS1}>
            Cameras:
          </Text>
          <Text>65</Text>
        </span>
      </s.CvvReportStatus>

      <s.CvvAddContainer>
        {/* Recorder 한 묶음 div -> 추후 배열로 맵핑 */}
        <div>
          <s.CvvListTitle>
            <label>
              <input type="checkbox" />{" "}
              <Text bold>Cerritos Office Parking Lot</Text>
            </label>
          </s.CvvListTitle>
          <s.CvvListWrapper>
            {addCvvListData().map((item, index) => (
              <s.CvvListItem key={index}>
                <s.CvvCameraThumbnail>
                  <DefaultThumbnail>
                    <img src={item.url} alt="cvv camera thumbnail" />
                  </DefaultThumbnail>
                  <input type="checkbox" />
                  <s.CvvCameraThumbnailTitle>
                    {item.cameraName}
                  </s.CvvCameraThumbnailTitle>
                </s.CvvCameraThumbnail>
              </s.CvvListItem>
            ))}
          </s.CvvListWrapper>
        </div>
      </s.CvvAddContainer>
    </s.ModalInnerHalf>,
    //Interval
    <s.ModalTableContainer>
      <s.InvervalTop>
        <label className="camera-name">
          <input type="checkbox" />{" "}
          <Text>Use one frame interval for all cameras</Text>
        </label>
        <s.TimelapseIntervalFrame isDisabled>
          <Text>Frame Interval:&nbsp;</Text>
          <s.TimelapseIntervalTopItem>
            <span>
              <SelectComponent options={intervalOptions} />
            </span>
            {/* daily, weekly, monthly 에 따라 선택 옵션들이 달라져야함 */}
            <span>
              <TimeSelect />
            </span>
          </s.TimelapseIntervalTopItem>
        </s.TimelapseIntervalFrame>
      </s.InvervalTop>
      <s.CvvAddContainer>
        <div>
          <s.CvvListTitle>
            <Text bold>Cerritos Office Parking Lot</Text>
          </s.CvvListTitle>
          <s.TimelapseWrapper>
            {addCvvListData().map((item, index) => (
              <s.TimelapseIntervalItem key={index}>
                <Text className="camera-name">{item.cameraName}</Text>
                <s.TimelapseIntervalFrame>
                  <Text>Frame Interval:&nbsp;</Text>
                  <s.TimelapseIntervalTopItem>
                    <span>
                      <SelectComponent options={intervalOptions} />
                    </span>
                    {/* daily, weekly, monthly 에 따라 선택 옵션들이 달라져야함 */}
                    <span>
                      <TimeSelect />
                    </span>
                  </s.TimelapseIntervalTopItem>
                  {/* <span>
                 <DateSelect />
                </span> */}
                </s.TimelapseIntervalFrame>
              </s.TimelapseIntervalItem>
            ))}
          </s.TimelapseWrapper>
        </div>
      </s.CvvAddContainer>
    </s.ModalTableContainer>,
    // preferences
    <s.ModalInnerHalf>
      <ModalInput label="Report Title" essential>
        <Input placeholder="Enter a title for this report" maxLength={255} />
      </ModalInput>
      <ModalInput label="Host">
        <Input
          disabled
          value="Steven Armstrong (sarmstron@digital-watchdog.com)"
        />
      </ModalInput>
      <ModalInput label="Description">
        <TextArea placeholder="Please enter a description" maxLength={255} />
      </ModalInput>
    </s.ModalInnerHalf>,
  ];

  return (
    <>
      <StepperComponent
        activeStep={props.page}
        steps={props.steps}
        onClick={props.onChangePage}
        data-testid="reports-add-timelapse-stepper-component-change-page"
      />

      {pages[props.page]}
      <s.ButtonWrapper>
        {props.page !== 0 && (
          <BigButton
            buttonType="cancel"
            label="Previous"
            onClickBtn={() => props.onChangePage("previous")}
            data-testid="reports-add-timelapse-button-change-page"
          />
        )}

        {props.page === pages.length - 1 ? (
          <BigButton
            label="Save"
            onClickBtn={() => props.onChangePage("save")}
            data-testid="reports-add-timelapse-button-change-page-2"
          />
        ) : (
          <BigButton
            buttonType="cancel"
            label="Next"
            onClickBtn={() => props.onChangePage("next")}
            data-testid="reports-add-timelapse-button-change-page-3"
          />
        )}
      </s.ButtonWrapper>
    </>
  );
}
